import type { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ScheduleViewSwitcherProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: Array<{ value: T; label: string; icon: LucideIcon }>;
  label: string;
}

export function ScheduleViewSwitcher<T extends string>({ value, onChange, options, label }: ScheduleViewSwitcherProps<T>) {
  return (
    <div className="schedule-view-switcher flex w-full items-center gap-1 rounded-md border border-border bg-card p-1 sm:w-auto" role="group" aria-label={label}>
      {options.map(({ value: option, label: optionLabel, icon: Icon }) => (
        <Button key={option} type="button" variant="ghost" size="sm" aria-pressed={value === option}
          onClick={() => onChange(option)} title={optionLabel}
          className={cn("min-w-0 flex-1 gap-1.5 px-2 text-xs sm:px-3 sm:text-sm", value === option ? "bg-primary/15 text-foreground ring-1 ring-inset ring-primary/40" : "text-muted-foreground")}>
          <Icon className="h-4 w-4 shrink-0" />
          <span className="truncate">{optionLabel}</span>
        </Button>
      ))}
    </div>
  );
}